import { TagProps } from "@chakra-ui/react";
import { FullEmailStatus, ShortEmailStatus } from "features/Resources/Email/Components/EmailStatus";
import { FullMessageStatus, ShortMessageStatus } from "features/Resources/Message/Components/MessageStatus";
import { FullTaskStatus, ShortTaskStatus } from "features/Resources/Task/Components/TaskStatus";
import { FullMeetingStatus } from "features/Resources/Meeting/Components/MeetingStatus";
import { ShortCheckpointStatus, FullCheckpointStatus } from "features/Resources/Checkpoint/Components/CheckpointStatus";
import { ActionSummaryData, ActionV2, ActionSummary } from "../models";
import { fromActionPrefixId } from "../helpers";

interface ActionStatusProps extends TagProps {
  action: ActionSummary | ActionV2;
}

export function ShortActionStatus({ action, ...rest }: ActionStatusProps) {
  if (!action) {
    return null;
  }
  const actionData: ActionV2 | ActionSummaryData = (action as ActionSummary)?.actionType ? action.action : action;
  const { resourceType } = fromActionPrefixId(actionData?.prefixId);

  switch (resourceType) {
    case "email":
      return <ShortEmailStatus status={actionData?.status} />;
    case "message":
      return <ShortMessageStatus status={actionData?.status} />;
    case "task":
      return <ShortTaskStatus status={actionData?.status} />;
    case "checkpoint":
      return <ShortCheckpointStatus status={actionData?.status} />;
    case "meeting":
    case undefined:
    default:
      return null;
  }
}

export function FullActionStatus({ action, ...rest }: ActionStatusProps) {
  if (!action) {
    return null;
  }
  const actionData: ActionV2 | ActionSummaryData = (action as ActionSummary)?.actionType ? action.action : action;
  const { resourceType } = fromActionPrefixId(actionData?.prefixId);

  switch (resourceType) {
    case "email":
      return <FullEmailStatus status={actionData?.status} />;
    case "message":
      return <FullMessageStatus status={actionData?.status} />;
    case "task":
      return <FullTaskStatus status={actionData?.status} />;
    case "meeting":
      return <FullMeetingStatus meeting={actionData} />;
    case "checkpoint":
      return <FullCheckpointStatus status={actionData?.status} />;
    case undefined:
    default:
      return null;
  }
}
